import axios from "axios";

export const BASE_API_URL =
  process.env.REACT_APP_SEARCH_API_URL || "https://dev-greenback-app-search-hbhxbwgzd6anbqb4.australiaeast-01.azurewebsites.net/api";

const axiosInstanceSearch = axios.create({
  baseURL: BASE_API_URL,
});

export default axiosInstanceSearch;
